import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VitaBeneficiario } from '../../../../services/vita-beneficiario.service';

export interface VitaBeneficiarioDetailDialogData {
  beneficiario: VitaBeneficiario;
  /**
   * Oculta "Usar este beneficiario". La libreta de gestión abre esta misma
   * ficha fuera de un envío, donde "usar" no lleva a ningún lado.
   */
  hideUse?: boolean;
  /**
   * Aviso a mostrar arriba de los datos (beneficiario no habilitado, datos
   * incompletos). Lo resuelve quien abre la ficha; el diálogo solo lo pinta.
   */
  aviso?: string | null;
}

export type VitaBeneficiarioDetailResult = 'use' | 'close' | null;

/**
 * Campos del schema de Vita que NO aportan al routing/identidad y no vale
 * la pena mostrar en el detalle (ruido). Se filtra en un getter de solo
 * lectura, cualquier key que Vita publique se muestra igual si no está acá.
 */
const HIDE_KEYS = new Set<string>([
  'purpose',
  'purpose_comentary',
  'fc_customer_type',
  'fc_legal_name',
  'fc_document_type',
  'fc_document_number',
  'fc_legal_address',
  'fc_birthdate',
  'fc_residence_country',
  'fc_trade_name',
  'fc_tax_id',
]);

@Component({
  selector: 'app-vita-beneficiario-detail-dialog',
  templateUrl: './vita-beneficiario-detail-dialog.component.html',
  styleUrls: ['./vita-beneficiario-detail-dialog.component.sass'],
})
export class VitaBeneficiarioDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<
      VitaBeneficiarioDetailDialogComponent,
      VitaBeneficiarioDetailResult
    >,
    @Inject(MAT_DIALOG_DATA)
    public data: VitaBeneficiarioDetailDialogData,
  ) {}

  get b(): VitaBeneficiario {
    return this.data.beneficiario;
  }

  get fullName(): string {
    const full = `${this.b.nombre || ''} ${this.b.apellidos || ''}`.trim();
    if (full) return full;
    const cn = (this.b.datosBancarios || {})['company_name'];
    return cn ? String(cn) : '—';
  }

  /** Entradas legibles del JSON bancario, salteando el ruido. */
  get datosBancariosEntries(): Array<{ key: string; value: any }> {
    const d = this.b.datosBancarios || {};
    return Object.keys(d)
      .filter((k) => !HIDE_KEYS.has(k))
      .sort()
      .map((k) => ({ key: k, value: d[k] }));
  }

  /** Label amigable para una key del JSON (convierte snake → Title Case). */
  labelFor(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  close(): void {
    this.dialogRef.close('close');
  }

  use(): void {
    this.dialogRef.close('use');
  }
}
